import './styles/index.less';
// import 'core-js/fn/date/now';
import 'core-js/fn/object/assign';
// import 'core-js/fn/string/trim';
import 'core-js/fn/promise';

import 'whatwg-fetch';

require('jquery.marquee');



/*** PLAYER ***/

let player;
let playerControl;
let dropDownOpen = false;

function backgroundPlayer() {
    player = new ASVideoPlayer('as-video-player', (window.mainVideoID || 'd8DEBj7QRfetLsRgFnGEyg'), {videosJS: { autoplay: true, muted: true }, ads: false });
    playerControl = player.getPlayer();

    playerControl.on('ready', function () {
        window.strSubSectionName = 'HOME';
    });

    $('.player-content').on('click', () => window.location.href = window.mainVideoLink);
}


/*** MARQUEE ***/

function marquee() {
    $(window).resize(() => {
        $('.ticker').marquee('destroy');

        initMarquee();
    });

    setTimeout(initMarquee, 1000);
}

function initMarquee() {
    $('.ticker').marquee({
        'startVisible': true,
        'allowCss3Support': false,
        'duration': ($(window).width() < 768) ? 7500 : 15000
    });
}


function initDropDown() {
    var acc = document.getElementsByClassName('drop-down');
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function() {
            this.classList.toggle('active');
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight === '300vh') {
                panel.style.maxHeight = '0vh';
            } else {
                panel.style.maxHeight = '300vh';
            }
        });
    }
    $('.drop-down').click(function(){
        var $elem = $('.drop-arrow');

        if (!dropDownOpen) {
            $({deg: 0}).animate({deg: 90}, {
                duration: 100,
                step: function(now) {
                    $elem.css({
                        transform: 'rotate(' + now + 'deg)'
                    });
                }
            });
        }
        else {
            $({deg: 90}).animate({deg: 0}, {
                duration: 100,
                step: function(now) {
                    $elem.css({
                        transform: 'rotate(' + now + 'deg)'
                    });
                }
            });
        }

        dropDownOpen = !dropDownOpen;
    });

}

var notification = {};

function initPushdown() {
    if (localStorage.getItem('pushdown') && localStorage.getItem('pushdown') === 'closed' && new Date().getTime() / 1000 < localStorage.getItem('pushdownDate')) {
        $('.pushdown').css('display','none');
    }
    else {
        setTimeout(function(){$('.pushdown').animate({'margin-top': '0px'},1000)},9000);
        pushdownRollover();
        $('.pushdown .close').on('click', handleClosePushdown);
    }
}

function checkLiveStream() {
    $.ajax('/api/schedule/live', {
        success: function(res) {
            if (!res.data.started) {
                updateLiveShow();
            }

            // the data has changed from previous values, so set the data, and update the content
            if (res.data.started !== notification.started) {
                notification = res.data;
                updateLiveShow();
            }

            setTimeout(checkLiveStream, 60000);
        }
    });
}

function updateLiveShow() {
    if (notification.id) {
        $('.video-title').text(notification.title)

        if (!notification.isReplay) $('.is-live-text').text('Streaming Live');
        else $('.is-live-text').text('Streaming Now');
    } else {
        $('.video-title').text('WMST');
        $('.is-live-text').text('Streaming Now');
    }
}

function handleClosePushdown() {
    localStorage.setItem('pushdown','closed');
    localStorage.setItem('pushdownDate',new Date().getTime() / 1000 + $('.pushdown').data('timeframe'));
    // $('.pushdown').css('display','none');
    var height = $('.pushdown').height();
    $('.pushdown').animate({'margin-top': (-1*height) + 'px'},1000,function(){$('.pushdown').hide()});
}


/*** NETBLOCK LISTENER ***/

function netblockListener() {
    // select the target node
    const target = document.getElementById('ad_bnr_atf_01');

    // create an observer instance
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                setTimeout(function () {
                    const height = target.offsetHeight;
                    if (height >= 90) $('.player-wrapper').addClass('netblocked');
                }, 2000);
            }
        });
    });

    // configuration of the observer:
    const config = { attributes: true, childList: true, characterData: true };

    // pass in the target node, as well as the observer options
    observer.observe(target, config);
}

function pushdownRollover() {
    $('.roku').on('mouseenter', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2019/02/05/roku.png');
    })
    $('.roku').on('mouseleave', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2018/12/19/Roku.png');
    })
    $('.fire').on('mouseenter', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2019/02/05/firetv.png');
    })
    $('.fire').on('mouseleave', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2018/12/19/firetv.png');
    })
    $('.appletv').on('mouseenter', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2019/02/05/appletv.png');
    })
    $('.appletv').on('mouseleave', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2018/12/19/appletv.png');
    })
    $('.ios').on('mouseenter', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2019/02/05/ios.png');
    })
    $('.ios').on('mouseleave', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2018/12/19/ios.png');
    })
    $('.android').on('mouseenter', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2019/02/05/android.png');
    })
    $('.android').on('mouseleave', function() {
        $(this).find('img').attr('src', 'https://i.cdn.turner.com/adultswim/big/img/2018/12/19/android.png');
    })
}

function subwayBackgroundImages() {
    $('#main-feature').css('background-image', 'url(\'' + $('#main-feature').data('image') + '\')');
    $('#behind-the-scenes').css('background-image', 'url(\'' + $('#behind-the-scenes').data('image') + '\')');
    $('#dev-meeting').css('background-image', 'url(\'' + $('#dev-meeting').data('image') + '\')');
}

/*** INITIALIZATION ***/

$(function () {

    backgroundPlayer();

    marquee();

    checkLiveStream();

    initPushdown();

    initDropDown();

    netblockListener();

    subwayBackgroundImages();
});



// WEBPACK FOOTER //
// ./src/client/index.js